import { RADIUS, SPACE, T } from '@/design/tokens';

/**
 * SkeletonCard — single loading placeholder card, token-driven.
 * Matches the proportions of a VehicleList / ProjectsPage card row.
 */
export function SkeletonCard() {
  return (
    <div
      aria-hidden="true"
      style={{
        background: T.card,
        border: `1px solid ${T.border}`,
        borderRadius: RADIUS.md,
        padding: SPACE.md,
      }}
    >
      <div style={{ height: 18, width: '60%', background: T.border, borderRadius: RADIUS.sm }} />
      <div
        style={{
          height: 12,
          width: '40%',
          marginTop: SPACE.sm,
          background: T.border,
          borderRadius: RADIUS.sm,
        }}
      />
    </div>
  );
}

/**
 * SkeletonList — renders `count` SkeletonCard items in a vertical grid.
 * Use for any screen that loads a list of cards.
 */
export function SkeletonList({ count = 2 }: { count?: number }) {
  return (
    <div role="status" aria-label="Loading…" style={{ display: 'grid', gap: SPACE.md }}>
      {Array.from({ length: count }, (_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
